module.exports = __webpack_public_path__ + "static/img/143.2ac7ff77.gif";